import { CommonActions } from './actions';
import { CommonMutations } from './mutations';

const states = () => ({
    rate: null,
    feeBuyPro: null,
    customerLevels: null,
    warehouse: null,
    chinaStore: null,
    feeGuarantee: null,
    showMenuLeft: true
});

export default {
    actions: CommonActions,
    mutations: CommonMutations,
    namespaced: true,
    state: states,
};
